var headersLang = [
    { text: "日本語", key: "ja" },
    { text: "英語", key: "en" },
    { text: "中国語", key: "cn" },
    { text: "ベトナム語", key: "vn" },
    { text: "ベンガル語", key: "bn" },
    { text: "ポルトガル語", key: "pt" }
]
export { headersLang }
